'use client'

import { PageError } from '@/components/shared/page-error'

export default function MarketingError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string }
  unstable_retry: () => void
}) {
  return (
    <PageError
      error={error}
      unstable_retry={unstable_retry}
      message="Something went wrong loading this page. Please try again."
    />
  )
}
